/**
 * Textos da ficha do sensor de baixo custo — funções puras (testadas em
 * `ar.test.ts`).
 */
import type { EscalaId } from './faixas';
import type { FonteSensor, Sensor } from './types';

/**
 * `fl` = 4: o mapa da RedeAr avisa "leituras divergentes" (|A − B| > 10 µg/m³
 * e ≥ 40% do maior) — só aviso, o valor continua. De 0 a 3 são os
 * `channel_flags` da PurpleAir (1 = canal A degradado, 2 = B, 3 = os dois).
 */
export const FL_AB = 4;

/** A escala em que cada rede mostra o próprio dado. A OpenAQ não classifica: vale a tabela oficial brasileira. */
export function escalaDoSensor(fonte: FonteSensor): EscalaId {
  return fonte === 'openaq' ? 'conama' : fonte;
}

function um(v: number): string {
  return v.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

/** "A 20,0 · B 8,4 µg/m³", "B 4,7 µg/m³ (só um canal)" ou `null`. */
export function textoBruto(b: Sensor['bruto']): string | null {
  if (!b) return null;
  if (b.a !== null && b.b !== null) return `A ${um(b.a)} · B ${um(b.b)} µg/m³`;
  const v = b.a ?? b.b;
  if (v === null) return null;
  return `${b.a !== null ? 'A' : 'B'} ${um(v)} µg/m³ (só um canal)`;
}
